import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const AnchorIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth}
            height={svgHeight}
            fill="none"
            viewBox="0 0 20 20"
            {...restProps}
        >
            <path
                fill={color}
                d="M15 13.333L18.334 10 15 6.667v2.5h-4.216a7.478 7.478 0 00-4.117-5.875 2.504 2.504 0 00-2.5-2.459 2.497 2.497 0 00-2.5 2.5c0 1.384 1.117 2.5 2.5 2.5.792 0 1.483-.375 1.942-.95A5.832 5.832 0 019.1 9.167H6.517A2.509 2.509 0 004.167 7.5a2.497 2.497 0 00-2.5 2.5c0 1.383 1.117 2.5 2.5 2.5 1.083 0 2-.7 2.35-1.667H9.1a5.844 5.844 0 01-2.983 4.284c-.467-.575-1.158-.95-1.95-.95a2.497 2.497 0 00-2.5 2.5 2.497 2.497 0 004.992.041 7.478 7.478 0 004.116-5.875H15v2.5z"
            ></path>
        </svg>
    );
};

export default React.memo(AnchorIcon);
